import React from "react";
import clsx from "clsx";
import { ErrorType } from "../../types/common";

export function NoSearchResults({ error }: { error: ErrorType }) {
	const getNoResultsContent = () => {
		if (error) {
			return (
				<>
					<h5>Search request failed</h5>
					<p>
						Please change your search parameters or contact us on{" "}
						<a href="mailto: dev@ch-aviation.com">
							dev@ch-aviation.com
						</a>
						.
					</p>
				</>
			);
		}

		return (
			<>
				<h5>No results</h5>
				<p>
					There are no results at the moment. <br />
					Start searching by filter.
				</p>
			</>
		);
	};

	return (
		<div className={clsx("no-search-results", { error })}>
			{getNoResultsContent()}
		</div>
	);
}
